/**
 * Function to show/hide the main site nav when scroll up/down the page
 */

(() => {
	// Find the header element
	const headerEl = document.querySelector('header.wp-block-template-part');
	if (!(headerEl instanceof HTMLElement)) return;

	// Keep track of queued callbacks
	let timeoutHandle = 0;

	// Record the initial scroll Y
	let previousScrollY = window.scrollY;

	// Delay in MS after a scroll before performing the update
	const updateDelay = 100;

	//
	function doUpdate() {
		// Get the current scroll Y
		const currentScrollY = window.scrollY;

		// Decide if the menu should be hidden
		headerEl.dataset.hidden = (
			0 === currentScrollY ||
			previousScrollY > currentScrollY
		) ? '0' : '1';

		// Updated the previous scroll Y
		previousScrollY = currentScrollY;
	}

	//
	function queueUpdate() {
		// Cancel any currently queued callback
		if (0 !== timeoutHandle) {
			clearTimeout(timeoutHandle);
			timeoutHandle = 0;
		}

		// Queue a new callback
		timeoutHandle = setTimeout(doUpdate, updateDelay);
	}

	// Listen for window scroll events
	window.addEventListener('scroll', queueUpdate, { passive: true });

	// Set the initial state
	queueUpdate();
})();